// Note -- when updating this function -- also update
// the one used in packages/editor/editor-plugin-ai/examples/utils/getDevFetchCustomHeaders.ts
export function _getFetchCustomHeaders(): HeadersInit {
	const currentHost = window.location.origin;

	switch (true) {
		case currentHost === 'https://statlas.prod.atl-paas.net':
			// Update this to add custom headers when run in atlaskit branch deploys
			// ie.
			// {
			//   'X-CloudID': 'Magic string'
			// }
			return {};
		default:
			return {};
	}
}

export function deriveHost(): string {
	const {
		origin = '',
		port = '',
		hostname = '',
	} = typeof window.location !== 'undefined' ? window.location : {};

	if (
		(hostname === 'localhost' && port !== '8081') ||
		[
			'atlaskit-website-staging.stg-east.frontend.public.atl-paas.net',
			'statlas.prod.atl-paas.net',
			'atlaskit.atlassian.com',
		].some((h) => hostname === h)
	) {
		return 'https://pug.jira-dev.com';
	}

	return origin;
}

export const convoAIStatelessApiURL: string = `${deriveHost()}/gateway/api/assist/chat/v1/invoke_agent/stream`;
export const convoAIApiUrl: string = `${deriveHost()}/gateway/api/assist/api/ai/v2/ai-feature/editor-ai/stream`;
export const shouldImproveWritingApiUrl: string = `${deriveHost()}/gateway/api/assist/api/ai/v2/ai-feature/editor-ai/should-improve-writing`;
// Cc-smarts path (new home, served by cc-smarts). Reached via the cc-smarts-ai-feature
// stargate route, which strips /gateway/api and prepends /api before forwarding to cc-smarts.
// Routing between this and the convo-ai URL above is gated by the SPRT experiment
// cc_smarts_should_improve_writing_migration (param routingMode). See CCI-16830.
export const shouldImproveWritingCcSmartsApiUrl: string = `${deriveHost()}/gateway/api/ai/v2/ai-feature/editor-ai/should-improve-writing`;
export const convoAIRovoApiURL: string = `${deriveHost()}/gateway/api/assist/rovo/v1/editor/conversation`; // + `/${channelID}/message/stream` at the end;
export const convoAIAuditLogApiURL: string = `${deriveHost()}/gateway/api/ai/v2/ai-feature/audit-logs`;
export const jiraIssueReformatterApiURL: string = `${deriveHost()}/gateway/api/assist/ai/v2/ai-feature/jira/issue/source-type/work-item/suggestions/stream`;

export const getAPIName = (endpoint: string): string => {
	switch (endpoint) {
		case convoAIStatelessApiURL:
			return 'assistance-service';
		case convoAIApiUrl:
			return 'convo-ai';
		case convoAIRovoApiURL:
			return 'rovo-agent';
		case convoAIAuditLogApiURL:
			return 'audit-logs';
		case jiraIssueReformatterApiURL:
			return 'jira-issue-reformatter';
		default:
			return 'unknown-api';
	}
};
